import { z } from 'zod'

/** Wire shape of the singleton row at /api/v1/settings.
 *  Matches `services/api/src/schemas/settings.py::SettingsOut`. */
export const settingsSchema = z.object({
  id: z.number().int(),
  minNoticeDays: z.number().int().nonnegative(),
  escalationLongLeaveDays: z.number().int().positive(),
  slackNotificationsEnabled: z.boolean(),
  aiAssistantEnabled: z.boolean(),
  birthdayWindowDays: z.number().int().min(0).max(31).default(15),
  replacementGrantReminderDays: z.array(z.number().int().min(1).max(90)).min(1).max(5),
  updatedAt: z.string().datetime(),
  updatedById: z.guid().nullable(),
})

export type Settings = z.infer<typeof settingsSchema>

/** PATCH body — every field optional. Sliders/toggles the user
 *  hasn't moved are simply omitted by the client. */
export const settingsUpdateSchema = z.object({
  minNoticeDays: z.number().int().min(0).max(60).optional(),
  escalationLongLeaveDays: z.number().int().min(1).max(60).optional(),
  slackNotificationsEnabled: z.boolean().optional(),
  aiAssistantEnabled: z.boolean().optional(),
  birthdayWindowDays: z.number().int().min(0).max(31).optional(),
  replacementGrantReminderDays: z
    .array(z.number().int().min(1).max(90))
    .min(1)
    .max(5)
    .optional(),
})

export type SettingsUpdate = z.infer<typeof settingsUpdateSchema>
